<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Create Customer Upload</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <CreateCustomerUploadForm />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import CreateCustomerUploadForm from "../../components/Kleyton/Forms/Customer/CreateCustomerUploadForm";

export default {
  page: {
    title: "Create Customer Upload",
    meta: [{ name: "Create Customer Upload", content: window.__env.app.description }]
  },

  components: {
    CreateCustomerUploadForm,
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "CreateCustomerUpload",
      title: "Create Customer Upload",
      items: [
        {
          text: "Customer",
          href: "/"
        },
        {
          text: "Create Customer Upload",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
